
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { handleScrollReset } from '@/utils/navigationUtils';

const SaasCallToAction: React.FC = () => {
  return (
    <section className="py-12 bg-primary-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold mb-4">Ready to Launch Your Referral Platform Business?</h2>
        <p className="text-xl mb-6 max-w-3xl mx-auto">
          Become a reseller today and start building your own recurring revenue stream.
        </p>
        <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-3">
          <Link to="/business-reseller-order" onClick={handleScrollReset}>
            <Button className="bg-white text-primary-blue hover:bg-gray-100 px-6 py-5 text-lg">
              Signup Reseller Plan <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SaasCallToAction;
